import { ScrollCaptain } from 'scroll-captain';
import './gated-content.scss';

class GatedContent {
    constructor (element) {
        // Defaults
        this.defaults = {
            initAttr: 'data-gatedcontent',
            previewBG1: 'preview-bg-1',
            previewBG2: 'preview-bg-2'
        };

        // Elements
        this.$root = element;

        // Properties
        this.animation = null;
    }

    initialize () {
        this.loadAnimation();
    }

    loadAnimation () {
        this.animation = new ScrollCaptain(this.$root, {
            initAttr: this.defaults.initAttr,
            bottom: '-50%',
            animatePreviewBg1: {
                targetSuffix: this.defaults.previewBG1,
                onscroll: true,
                duration: 0,
                rotate: { 0: -5, 50: -15}
            },
            animatePreviewBg2: {
                targetSuffix: this.defaults.previewBG2,
                onscroll: true,
                duration: 0,
                rotate: { 0: -1, 50: -7}
            },
            onScroll: () => {}
        });
    }
}

export { GatedContent };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-gatedcontent="root"]');
        $$roots.forEach($root => {
            const $rootAPI = new GatedContent($root);
            $rootAPI.initialize();
        });
    }
});
